import React , { Component } from 'react';
import HOC from './HOC';
import InputText from '../components/formulario/InputText';
import { CONSTANTES } from '../utils/Constantes';
import Select from '../components/formulario/Select';
import Boton from '../components/formulario/Boton';
import Utils from '../utils/Validate';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col';
import Popover from 'react-bootstrap/Popover';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Modal from 'react-responsive-modal';
import ReactTable from 'react-table';
import {ReactTableDefaults} from 'react-table';
import 'react-table/react-table.css';
import 'jsoneditor-react/es/editor.min.css';
import moment from 'moment';
import { Auth, Storage } from 'aws-amplify';
import ModalGenerico from '../components/comunes/ModalGenerico';
import Footer from '../components/comunes/Footer';
import Breadcrumb from '../components/comunes/Breadcrumb';
import CrearUsuario from '../containers/CrearUsuario';
import ActualizarUsuario from '../containers/ActualizarUsuario';
import ActualizarContrasena from '../containers/ActualizarContrasena';
import EstadoUsuario from '../containers/EstadoUsuario';
import ProcesoMasivoUsuarios from '../containers/ProcesoMasivoUsuarios';

class ListarUsuarios extends Component {
    state = {
        listaUsuarios   : [],
        tampagina   : 3,
        isLoading       : false,
        m_modal         : '',
        casoModal: '',       
        open: false,        
        atributo: 'username||Username',
        atributoValor: '',
        v_atributo: true,
        v_atributoValor: true,
        c_atributo: '',
        c_atributoValor: '',
        username: '',
       
        v_subcanal: '',
		
        listaFiltroUsuario: [
            {
                value: "username",
                detalle: 'Username'
            },
            {
                value: "email",
                detalle: 'Email'
            }
		],		
        //        
        submenu: "",
        actUsuario : {},
        //opciones
        opciones: []
    }
    static tipoFiltro = 'begin';
    static limit = 10;
    static textoSubMenu = {
        crearUsuario: 'Crear Usuario',
        actualizarUsuario: 'Actualizar Usuario',
        actualizarContrasena: 'Actualizar Contraseña',
        estadoUsuarioHabilitar: 'Habilitar Usuario',
        estadoUsuarioInhabilitar: 'Inhabilitar Usuario',
        buscarUsuario: 'Búsqueda de Usuario',
        procesoMasivoUsuarios: 'Carga Masiva de Usuarios'
    };

    previousPageHandler = () => {
        this.setLocalStorage("FLUJO","1");
        this.props.props.history.push({ pathname : CONSTANTES.RUTA.detalle });
    }
    setLocalStorage = (key, value) => {
        localStorage.setItem(key, JSON.stringify(value));
      }
    
    getLocalStorage = (key) => {
        if(localStorage.hasOwnProperty(key)){
          const local = localStorage.getItem(key);
          return JSON.parse(local);
        }else{
          return {};
        }
        
      }

    componentWillMount() {
    }
    async componentDidMount(){
		if("true" !== localStorage.getItem('login')){
            await Auth.signOut();
        }        
        Auth.currentUserInfo().then(response => {
            if (response && response.attributes != null){
              this.setState({
                username: response && response.attributes.email ? response.attributes.email : ''
              });
            }
        });
        this.iniciarOpciones();
        this.consultarTodosUsuariosService({limit:  ListarUsuarios.limit});
    }
    iniciarOpciones = () =>{
        let opciones= this.getLocalStorage('permisos');
        this.setState({opciones: opciones, accionDefault: ListarUsuarios.textoSubMenu['buscarUsuario']});
    }
    consultarAlVolver = () =>{
        if(this.state.ultBusqueda=='all'){
            let request = {limit:  ListarUsuarios.limit};           
            this.consultarTodosUsuariosService(request);
        }else{
            let request = {
                attributeName: this.state.c_atributo.split(CONSTANTES.SEPARADOR)[0],
                filterType: ListarUsuarios.tipoFiltro,
                attributeValue: this.state.c_atributoValor,
                limit: ListarUsuarios.limit          
            }
            this.consultarUsuariosService(request);
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.props.location !== this.props.props.location) {
            this.setState({submenu: ''});
        }
    }
    timer = () => {
        Auth.currentSession().then(response =>{
            var exp = moment.unix(response.accessToken.payload.exp).format('DD/MM/YYYY hh:mm:ss');
            var fecha_actual = moment(new Date()).format('DD/MM/YYYY hh:mm:ss');
            if(fecha_actual > exp){
                this.cerrarSesion();
            }
		})
		.catch(error =>{
			this.props.props.history.push({ pathname : CONSTANTES.RUTA.login }); 
		});
    }
    borrarFiltros = () =>{
        this.setState({atributo: '||',
                        atributoValor: ''});
    }
    validarFormulario = (e) => {
            let response = true;
            if ((this.state.atributo === CONSTANTES.SEPARADOR || this.state.atributo === '') && this.state.atributoValor !== ''){
                this.setState({v_atributo:false});
                response = false;
            }else{
                this.setState({v_atributo:true})
            }
    
            if (this.state.atributoValor == '' && this.state.atributo !== CONSTANTES.SEPARADOR){
                this.setState({v_atributoValor:false});
                response = false;
            }else{
                this.setState({v_atributoValor:true})
            }
        return response;
    }
    validarCampo = (e) => {
        let { value , name } = e.target;
        this.setState({['v_' + name] : Utils.validarCampo(name, value)}, () => {
        })   
    }
    onChange = (e) => {
        let { name, value } = e.target;
        this.setState({ [name] : value }, () => {
        });        
    }
    
    /** OBTENER REMESAS */
    consultarUsuariosService = (params) => {
        this.props.mostrarLoading();
        this.props.props.callServiceUsuarios("GET","usuarios/filtrar", {...params}).then(response => {
            // console.log(response);
            if(response){
                console.log(response);
                if(200 === response.statusCode  && 0 === response.body.responseCode){
                    let usuarios = [];
                    let nextStart = response.body.data.nextStart;
                    let numUsuarios= response.body.data.estimatedNumberOfUsers;
                    usuarios = response.body.data.users;
                    let listaUsuarios = params.nextStart?this.state.listaUsuarios.concat(usuarios):usuarios;
                    this.setState({
                        tampagina: listaUsuarios.length==0?3:listaUsuarios.length,
                        listaUsuarios:listaUsuarios,
                        nextStart: nextStart,
                        numeroUsuariosEstimado: numUsuarios,
                        c_atributo: this.state.atributo,
                        c_atributoValor: this.state.atributoValor,
                        ultBusqueda: ''
                    }, () => {
                    })
                }else{
                    this.props.mostrarModal("mensajeUsuario", null, response.body.responseMessage);
                }
                this.props.ocultarLoading();
            }
        }).catch( error => {
            console.error(error);
            this.props.ocultarLoading();
            this.props.mostrarModal("mensajeUsuario", null, "Hemos tenido problemas con nuestro sistema.");
        });
    }
    consultarTodosUsuariosService = (params) => {
        this.props.mostrarLoading();
        this.props.props.callServiceUsuarios("GET","usuarios", {...params}).then(response => {
            // console.log(response);
            if(response){
                console.log(response);
                if(200 === response.statusCode  && 0 === response.body.responseCode){
                    let usuarios = [];
                    let nextStart = response.body.data.nextStart;
                    let numUsuarios= response.body.data.estimatedNumberOfUsers;
                    usuarios = response.body.data.users;
                    let listaUsuarios = params.nextStart?this.state.listaUsuarios.concat(usuarios):usuarios;
                    this.setState({
                        tampagina: listaUsuarios.length==0?3:listaUsuarios.length,
                        listaUsuarios:listaUsuarios,
                        nextStart: nextStart,
                        numeroUsuariosEstimado: numUsuarios,
                        ultBusqueda: 'all'
                    }, () => {
                    })
                }else{
                    this.props.mostrarModal("mensajeUsuario", null, response.body.responseMessage);
                }
                this.props.ocultarLoading();
            }
        }).catch( error => {
            console.error(error);
            this.props.ocultarLoading();
            this.props.mostrarModal("mensajeUsuario", null, "Hemos tenido problemas con nuestro sistema.");
        });
    }
    cerrarSesion = () => {
        this.props.mostrarLoading();      
        new Promise((resolve, reject) => {
          setTimeout(function(){
			//localStorage.clear();
			
            resolve(true);
          },500)
        }).then(() => {
          this.props.ocultarLoading();
          this.props.props.history.push({ pathname : CONSTANTES.RUTA.login });
        })
      }

    consultarUsuarios = (reload) => {
        let request = {
            attributeName: reload?this.state.atributo.split(CONSTANTES.SEPARADOR)[0]:this.state.c_atributo.split(CONSTANTES.SEPARADOR)[0],
            filterType: ListarUsuarios.tipoFiltro,
            attributeValue: reload?this.state.atributoValor:this.state.c_atributoValor,
            limit: ListarUsuarios.limit          
        }
        if(!reload && this.state.nextStart)
            request.nextStart = this.state.nextStart;
        this.consultarUsuariosService(request);
    }
    buscar = () => {
        if(this.validarFormulario()){
            if(!(this.state.atributo === CONSTANTES.SEPARADOR && this.state.atributoValor == ''))
                this.consultarUsuarios(true);
            else
                this.consultarTodosUsuariosService({limit:  ListarUsuarios.limit});
        }
            
    }   
    mostrarMas = () => {
        if(this.state.ultBusqueda=='all'){
            let request = {limit:  ListarUsuarios.limit};
            if(this.state.nextStart)
                request.nextStart = this.state.nextStart;
            this.consultarTodosUsuariosService(request);
        }else{
            this.consultarUsuarios(false);
        }
    }
    irCrearUsuario = () =>{
        this.setState({submenu: 'crearUsuario',
                        accionActual: ListarUsuarios.textoSubMenu['crearUsuario']});
        window.scrollTo(0, 0);
    }
    irActualizarUsuario = () =>{
        this.setState({submenu: 'actualizarUsuario',
                        accionActual: ListarUsuarios.textoSubMenu['actualizarUsuario']});
        window.scrollTo(0, 0);
    }
    irActualizarContrasena = () =>{
        this.setState({submenu: 'actualizarContrasena',
                        accionActual: ListarUsuarios.textoSubMenu['actualizarContrasena']});
        window.scrollTo(0, 0);
    }
    irEstadoUsuario = () =>{
        this.setState({submenu: 'estadoUsuario',
                        accionActual: !this.state.actUsuario.enabled?ListarUsuarios.textoSubMenu['estadoUsuarioHabilitar']:ListarUsuarios.textoSubMenu['estadoUsuarioInhabilitar']});
        window.scrollTo(0, 0);
    }
    irProcesoMasivoUsuarios = () =>{
        this.setState({submenu: 'procesoMasivoUsuarios',
                      accionActual: ListarUsuarios.textoSubMenu['procesoMasivoUsuarios']});
        window.scrollTo(0, 0);
    }
    actualizarUsuario = (usuario) =>{
        usuario.attributes.map(e=>{
            usuario[e.name] = e.value;
        });        
        this.setState({actUsuario:usuario},()=>this.irActualizarUsuario());        
    }
    actualizarContrasena = (usuario) =>{
        usuario.attributes.map(e=>{
            usuario[e.name] = e.value;
        });        
        this.setState({actUsuario:usuario},()=>this.irActualizarContrasena());        
    }
    estadoUsuario = (usuario) =>{
        usuario.attributes.map(e=>{
            usuario[e.name] = e.value;
        });        
        this.setState({actUsuario:usuario},()=>this.irEstadoUsuario());        
    }
    irListarUsuario = () =>{
        this.setState({submenu: "",
                      accionActual: ""});
        window.scrollTo(0, 0);
    }    
    render=()=>{
        const fontSize = 11;
        var { open, listaUsuarios, page } = this.state;
        //listaRemesas = data;
        ReactTableDefaults.column= {...ReactTableDefaults.column, headerClassName: 'tableUserHeader', className:'tableUserCell'};
        //ReactTableDefaults.columnHeaderProps= {...ReactTableDefaults.columnHeaderProps, headerClassName: 'tableUserHeader2', className:'tableUserCell2'};
        let columns = [{
            Header: 'USERNAME',
            accessor: 'username',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 120,
            style: {
                fontSize: fontSize,
            }
        }, {
            Header: 'FECHA ÚLTIMA MODIFICACIÓN',
            accessor: 'lastModifiedDate',
            Cell: props => <div style={{ textAlign: "center" }}>{ moment(props.value).format('DD/MM/YYYY HH:mm:ss')}</div>,
            minWidth: 80,
            style: {
                fontSize: fontSize,
            },
        }, {
            Header: 'CORREO ELECTRÓNICO',
            accessor: 'email',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 170,
            style: {
                fontSize: fontSize,
            },
        },  {
            Header: 'TIPO DE USUARIO',
            accessor: 'type',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 80, 
            style: {
                fontSize: fontSize,
            },
        }, {
            Header: 'ESTADO',
            accessor: 'enabled',
            Cell: props => <div className ={"div-estado "+(props.value?"activo":"inactivo")} ><div className ={"point-div-estado "+(props.value?"activo":"inactivo")}/>{props.value?"Activo":"Inactivo"}</div>,
            minWidth: 100,
            style: {
                fontSize: fontSize,
            },
        }, {
            Header: '',
            Cell: props => 
                 {
                     if(props.original.type == 'EXTERNO') 
                        return(<OverlayTrigger
                            rootClose = {true}
                            rootCloseEvent = {'click'}
                            trigger="click"
                            placement={"auto"}
                            overlay={
                                <Popover id={`popover-positioned`}>                       
                                <Popover.Content>
                                    <div className="div-popover">
                                        <div className="row" onClick={()=>this.actualizarUsuario(props.original)}>
                                            <div className ="icon-eye"/> Actualizar datos
                                        </div>
                                        <div className="row" onClick={()=>this.actualizarContrasena(props.original)}>
                                            <div className ="icon-document"/> Actualizar contraseña
                                        </div> 
                                        <div className="row" onClick={()=>this.estadoUsuario(props.original)}>
                                            <div className ={props.original.enabled?"icon-ina":"icon-habi"}/> {props.original.enabled?"Inhabilitar":"Habilitar"}
                                        </div>   
                                    </div>
                                </Popover.Content>
                                </Popover>
                            }
                            >
                            <div className="div-option">                    
                                <div className ="icon-option"/>
                            </div>
                            </OverlayTrigger>);
                    else
                        return null;
                 }
            ,
            filterable: false,
            minWidth: 30,
            style: {
                fontSize: fontSize,
            }
        }];
        
        switch (this.state.submenu) {
            case 'crearUsuario':
                return (<CrearUsuario  {...this} {...this.props} {...this.state}/>);
                break;        
            case 'actualizarUsuario':
                return (<ActualizarUsuario  {...this} {...this.props} usuario={this.state.actUsuario} {...this.state}/>);
                break;
            case 'actualizarContrasena':
                return (<ActualizarContrasena  {...this} {...this.props} usuario={this.state.actUsuario} {...this.state}/>);
                break;
            case 'estadoUsuario':
                return (<EstadoUsuario  {...this} {...this.props} usuario={this.state.actUsuario} {...this.state}/>);
                break;
            case 'procesoMasivoUsuarios':
                return (<ProcesoMasivoUsuarios  {...this} {...this.props} {...this.state}/>);
                break;
            default:
                return(
                    <section className="showMntUsuarios container-fluid container-filtercolor">
                            <div className="container container-filter justify-content-start mb-flex-column">
                                <div className="container-filter-info justify-content-start mb-full">
                                    <div className="">
                                        <Breadcrumb opciones={this.state.opciones} accionActual={this.state.accionActual} accionDefault={this.state.accionDefault}  irDefault={this.irListarUsuario}/>
                                        <h1><b>Búsqueda</b></h1>
                                        <p>Aquí gestiona todos los usuarios del Portal.</p>                                       
                                    </div>                            
                                </div>                       
                                                        
                            </div>
                            <div className="container-fluid w100 d-flex mb-flex-column justify-content-between">
                                <div className={"container boxBuscar mb-w100 d-flex flex-column flex-justify-between w100"}>
                                    <div className="seccionFiltrar">
                                        <Row className={"row-form-v2"}>                                                
                                            <Col className="s12 m3 l2" style={{float: "left"}}>
                                                <button className={"botonFormulario right btn-small btn-w no-box-shadow"} onClick={this.irProcesoMasivoUsuarios} style={{marginBottom: "10px"}}>Importar Usuarios</button>
                                            </Col>
                                        </Row>
                                        <Row className={"row-form-v2"}>
                                            <Col className="s12 m3 l2" style={{float: "left"}}>
                                                <button className={"botonFormulario right btn-small btn-w no-box-shadow"} onClick={this.irCrearUsuario} style={{marginBottom: "10px"}}>Crear un Usuario</button>
                                            </Col>
                                            <Col className="s12 m3 l2 col-form-v2">
                                                    <Select 
                                                        lista = {this.state.listaFiltroUsuario}                                                 
                                                        titulo = "Filtro"
                                                        placeholder = "valor"                                                
                                                        name = "atributo"
                                                        habilitarValorInicial = {false}
                                                        value = {this.state.atributo}
                                                        onChange = {(e) => { 
                                                                            this.onChange(e); 
                                                                            this.validarCampo(e);
                                                                    }}
                                                        validate = {this.state.v_atributo}/>
                                            </Col>
                                            <Col className="s12 m6 l4 col-form-v2" >
                                                    <InputText
                                                        name="atributoValor"
                                                        alias= "valor"
                                                        value={this.state.atributoValor}
                                                        onBlur={this.validarCampo} 
                                                        onChange={this.onChange}
                                                        validate = {this.state.v_atributoValor}
                                                        clase = {"input-v2"}
                                                        placeholder = {this.state.atributo?this.state.atributo.split(CONSTANTES.SEPARADOR)[1]:"Username, Email"}  />
                                                </Col>                       
                                            <Col className="s12 m3 l2" style={{float: "left"}}>
                                                 <button className={"botonFormulario right btn-small btn-w no-box-shadow"} onClick={this.buscar} style={{marginBottom: "10px"}}>Buscar</button>
                                            </Col>
                                            <Col className="s12 m3 l2 col-form-v3">
                                                <div className='form-filtro' style={{margin: "auto", display:"flex", cursor: "pointer"}} onClick={this.borrarFiltros} >
                                                    <div className="icon-delete"/>
                                                     BORRAR FILTROS
                                                </div>
                                            </Col>
                                        </Row>                                      
                                        <Row>
                                            <Col className="s12 m2 l1 form-filtro" style={{float: "right"}}>
                                                TOTAL: {this.state.numeroUsuariosEstimado}
                                            </Col>
                                        </Row>                                          
                                        <div>
                                            <ReactTable
                                                    className={"-striped"}
                                                    style={{backgroundColor : "white"}}                                         
                                                    defaultPageSize={10}
                                                    pageSize={this.state.tampagina}
                                                    data={listaUsuarios}
                                                    columns={columns}
                                                    showPagination= {false}
                                                    //previousText={"Anterior"}
                                                    //nextText={"Siguiente"}
                                                    
                                                    loadingText={"Cargando..."}
                                                    noDataText={"No hay datos para mostrar"}
                                                    //pageText={"Página"}
                                                    //ofText={"de"}
                                                    //rowsText={"filas"}
                                                    //pageSizeOptions={[10, 20, 50]}
                                                    manual
                                                    //page={page}
                                                    //pages={this.state.pages}
                                                    //sorted={this.state.sorted}
                                                    // onPageChange={page => this.setState({ page })}
                                                                                                        
                                                    getNoDataProps={(state, rowInfo, column) => {
                                                        return {
                                                          style: {
                                                            background: 'none',
                                                            top: '63%'
                                                          }
                                                        }
                                                      }}                                                
                                            />
                                        </div>
                                        { this.state.nextStart &&
                                        <Row>
                                            <Col className="s12 m12 l12" style={{display:"flex"}}>
                                                <div className={"font-footer div-load"} style={{margin: "auto", display:"flex"}} onClick={this.mostrarMas}>
                                                    <div className ={"icon-load"}/> MOSTRAR MÁS
                                                </div>    
                                            </Col>
                                        </Row>
                                        }
                                        <Row className="footer-v2">
                                            <Col className="s12 m4 l2" style={{float: "left", paddingLeft: "0px"}}>                                        
                                                    <Col className="s12 m12 l12 font-footer "> 
                                                        Estados 
                                                    </Col>                                        
                                                    <Col className="s12 m6 l6 footer-v2" style={{float: "left"}}>                                            
                                                        <div className ={"div-estado activo"}>
                                                            <div className ={"point-div-estado activo"}/>
                                                            Activo
                                                        </div>
                                                    </Col>
                                                    <Col className="s12 m6 l6 footer-v2" style={{float: "left"}}>
                                                        <div className ={"div-estado inactivo"}>
                                                            <div className ={"point-div-estado inactivo"}/>
                                                            Inactivo
                                                        </div>
                                                    </Col>                                       
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                            
                            </div>   
                    </section>);
                break;
        }
        
        
    }
}
export default HOC(ListarUsuarios);